<template lang="pug">
div
  #rewardModal.modal(:class="{'d-flex': showPrize == true}")
    .modal-content
      img#rewardImage.modal-bg(:src="`/images/event/eggsmash/pop-up-RM${prizeWon}.png`" alt='pop up image')
      #closeModal.close-modal(@click="togglePop")
      .modal-actions
        img#claimBtn(width='150px' src='/images/event/eggsmash/claim.png' alt='claim button' @click="$router.push('/inbox').catch(err => {})")
        img#continueBtn(src='/images/event/eggsmash/continue_spin.png' alt='continue button' @click="togglePop")
  main
    section.banner
      img(src='/images/event/eggsmash/title.png' alt='lucky smash')
      .smash-button
        .smash-count
          img(width='100%' src='/images/event/eggsmash/smash-count-button.png' alt='smash count')
          p#smashCount {{tokenBalance}}
    section.smash-div
      p Make sure Balance is Below RM1 To Smash Eggs, or T&amp;C Applies
      .tray-div
        .tray-images
          img.coins-left(width='80px' src='/images/event/eggsmash/coins.png' alt='gold coins')
          img.coins-right(width='80px' src='/images/event/eggsmash/coins.png' alt='gold coins')
          img.tray(width='100%' src='/images/event/eggsmash/tray_bg.png' alt='egg tray')
        .eggs-grid
          .egg-smash
            img.egg(v-if="crack1 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg1}.png`" )
            .smash-btn(v-if="crack1 == false" @click="smashEgg(1)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack2 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg2}.png`" )
            .smash-btn(v-if="crack2 == false" @click="smashEgg(2)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack3 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg3}.png`" )
            .smash-btn(v-if="crack3 == false" @click="smashEgg(3)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack4 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg4}.png`" )
            .smash-btn(v-if="crack4 == false" @click="smashEgg(4)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack5 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg5}.png`" )
            .smash-btn(v-if="crack5 == false" @click="smashEgg(5)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack6 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg6}.png`" )
            .smash-btn(v-if="crack6 == false" @click="smashEgg(6)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack7 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg7}.png`" )
            .smash-btn(v-if="crack7 == false" @click="smashEgg(7)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack8 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg8}.png`" )
            .smash-btn(v-if="crack8 == false" @click="smashEgg(8)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack9 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg9}.png`" )
            .smash-btn(v-if="crack9 == false" @click="smashEgg(9)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack10 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg10}.png`" )
            .smash-btn(v-if="crack10 == false" @click="smashEgg(10)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack11 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg11}.png`" )
            .smash-btn(v-if="crack11 == false" @click="smashEgg(11)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          .egg-smash
            img.egg(v-if="crack12 == false" width='100px' src='/images/event/eggsmash/egg.png' alt='egg')
            img.d-block(v-else width='100px' :src="`/images/event/eggsmash/RM${egg12}.png`" )
            .smash-btn(v-if="crack12 == false" @click="smashEgg(12)")
              img(width='100%' src='/images/event/eggsmash/smash.png' alt='smash button')
          
    section.t_c
      template(v-if="getLanguage=='en'")
        p TERMS AND CONDITIONS
        p Token are based on Daily Accumulated Deposit:
          ul
            li Deposit RM50 – RM100: Get 1 token
            li Deposit RM101 – RM250: Get 2 tokens
            li Deposit RM251 – RM499: Get 5 tokens
            li Deposit RM500 and above: Get 7 tokens
          ul
            li Rewards: RM2, RM5, RM28, RM38, RM58, RM388, RM588
            li Maximum 7 tokens can be earned per day
            li Maximum 10 tokens can be stored
            li X3 turnover required before withdrawal
            li Max withdrawal: RM588
            li Valid for EpicWin, MegaH5 and Fachai games only
            li Balance must be below RM1 before claiming
            li Otherwise, deposit will follow Epic Lucky Smash T&C
        p General Terms and Conditions
        p
          ul
            li Withdrawal is limited to 5 times per day.
            li EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice
            li Minimum withdrawal amount is RM10
      template(v-if="getLanguage=='my'")
        p Terma & Syarat
        p Token berdasarkan Jumlah Deposit Harian:
          ul
            li Deposit RM50 – RM100: Dapat 1 token
            li Deposit RM101 – RM250: Dapat 2 token
            li Deposit RM251 – RM499: Dapat 5 token
            li Deposit RM500 dan ke atas: Dapat 7 token
          ul
            li Ganjaran: RM2, RM5, RM28, RM38, RM58, RM388, RM588
            li Maksimum 7 token boleh diperoleh setiap hari
            li Maksimum 10 token boleh disimpan
            li Keperluan X3 turnover sebelum pengeluaran
            li Pengeluaran maksimum: RM588
            li Hanya boleh main EpicWin, MegaH5 dan Fachai sahaja
            li Baki mesti kurang daripada RM1 sebelum menebus promosi
            li Jika tidak, deposit akan mengikut Terma & Syarat Epic Lucky Smash
        p Terma & Syarat Umum
        p
          ul
            li Pengeluaran dihadkan kepada 5 kali sehari
            li EpicWin berhak sepenuhnya untuk menamatkan akaun ahli sekiranya berlaku pelanggaran T&C tanpa notis awal
            li Jumlah pengeluaran minimum adalah RM10
      template(v-if="getLanguage=='zh'")
        p 条款与条件
        p 代币根据每日累计存款发放：
          ul
            li 存款 RM50 – RM100：获得 1 个代币
            li 存款 RM101 – RM250：获得 2 个代币
            li 存款 RM251 – RM499：获得 5 个代币
            li 存款 RM500 以上：获得 7 个代币
          ul
            li 奖励金额：RM2, RM5, RM28, RM38, RM58, RM388, RM588
            li 每日最多可获得 7 个代币
            li 最多可储存 10 个代币
            li 提款需完成 X3 流水要求
            li 提款金额上限为 RM588
            li 仅限于 EpicWin, MegaH5 和 Fachai 游戏
            li 申领奖励前余额必须低于 RM1
            li 否则，存款将遵循 Epic Lucky Smash 条款与条件
        p 一般条款与条件
        p
          ul
            li 每日最多提款 5 次
            li 若违反条款与条件，EpicWin 有权在无事先通知的情况下终止会员账户
            li 最低提款金额为 RM10
</template>
<script>
export default{
	data(){
		return{
      crack1: false,
      crack2: false,
      crack3: false,
      crack4: false,
      crack5: false,
      crack6: false,
      crack7: false,
      crack8: false,
      crack9: false,
      crack10: false,
      crack11: false,
      crack12: false,
      egg1: null,
      egg2: null,
      egg3: null,
      egg4: null,
      egg5: null,
      egg6: null,
      egg7: null,
      egg8: null,
      egg9: null,
      egg10: null,
      egg11: null,
      egg12: null,
      startRender: false,
			goDepo:true,
      tokenBalance: null,
      showPrize:false,
      prizeWon: null
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.reset()
      }else{
        this.getSmashToken()
      }
    }
  },
  mounted() {
    // this.addStylesheet();
    window.scroll(0,0)
    // document.body.classList.add("custom-font");
    this.getSmashToken()
  },
  beforeDestroy() {
    this.reset()
    // this.removeStylesheet();
    // document.body.classList.remove("custom-font");
  },
	methods:{
    goTo(){
      this.$router.push("/inbox").catch(error =>{})
    },
    togglePop(){
      this.showPrize = !this.showPrize
    },
    claimAct(){
      this.togglePop()
    },
    getSmashToken(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getSmashToken", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.tokenBalance = response.data[0].token
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    smashEgg(src){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/smashEgg", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                switch(src){
                  case 1:
                    this.egg1 = response.data[0].prize_amount
                    this.crack1 = true
                    break;
                  case 2:
                    this.egg2 = response.data[0].prize_amount
                    this.crack2 = true
                    break;
                  case 3:
                    this.egg3 = response.data[0].prize_amount
                    this.crack3 = true
                    break;
                  case 4:
                    this.egg4 = response.data[0].prize_amount
                    this.crack4 = true
                    break;
                  case 5:
                    this.egg5 = response.data[0].prize_amount
                    this.crack5 = true
                    break;
                  case 6:
                    this.egg6 = response.data[0].prize_amount
                    this.crack6 = true
                    break;
                  case 7:
                    this.egg7 = response.data[0].prize_amount
                    this.crack7 = true
                    break;
                  case 8:
                    this.egg8 = response.data[0].prize_amount
                    this.crack8 = true
                    break;
                  case 9:
                    this.egg9 = response.data[0].prize_amount
                    this.crack9 = true
                    break;
                  case 10:
                    this.egg10 = response.data[0].prize_amount
                    this.crack10 = true
                    break;
                  case 11:
                    this.egg11 = response.data[0].prize_amount
                    this.crack11 = true
                    break;
                  case 12:
                    this.egg12 = response.data[0].prize_amount
                    this.crack12 = true
                    break;
                  default:

                }
                this.prizeWon = response.data[0].prize_amount
                this.showPrize = true
                this.getSmashToken()
              }
              
            } else {
              this.showPrize = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.showPrize = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }else{
        this.$router.push("/login").catch(err => {});
      }
    },
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
    },
    reset(){
      this.crack1= false
      this.crack2= false
      this.crack3= false
      this.crack4= false
      this.crack5= false
      this.crack6= false
      this.crack7= false
      this.crack8= false
      this.crack9= false
      this.crack10= false
      this.crack11= false
      this.crack12= false
      this.egg1 = null
      this.egg2 = null
      this.egg3 = null
      this.egg4 = null
      this.egg5 = null
      this.egg6 = null
      this.egg7 = null
      this.egg8 = null
      this.egg9 = null
      this.egg10 = null
      this.egg11 = null
      this.egg12 = null
      this.showPrize = false
      this.tokenBalance = null
    }
	}
}
</script>
<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
}

main {
  width: 400px;
  margin: 0 auto;
  color: white;
  font-family: "Roboto", sans-serif;
  z-index: -2;
}

.banner {
  background-image: url("/images/event/eggsmash/banner.png");
  background-size: cover;
  background-position: center;
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: rgb(112, 22, 171);
}

.banner > img {
  width: 90%;
}

.banner .smash-button {
  position: absolute;
  bottom: 5px;
  left: 5px;
}

.banner .smash-button .smash-count {
  position: relative;
  width: 150px;
}

.banner .smash-button .smash-count p {
  font-size: 18px;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 14px;
  color: #fefeee;
  font-family: "Carter one", system-ui;
  font-weight: 800;
  font-style: italic;
  text-shadow: -1px 1px 0 #5a2f05, 1px 1px 0 #5a2f05;
}

.smash-div {
  padding: 16px;
  background: linear-gradient(
    to top,
    rgb(112, 22, 171),
    rgb(112, 22, 171),
    rgb(112, 22, 171),
    rgb(112, 22, 171),
    rgb(112, 22, 171),
    rgb(112, 22, 171),
    rgba(97, 15, 151, 0.9)
  );
}

.smash-div > p {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 10px;
  font-style: italic;
  color: white; /* or any main text color */
  text-shadow: -1px -1px 0 rgb(129, 29, 195),
    1px -1px 0 rgb(129, 29, 195), -1px 1px 0 rgb(129, 29, 195),
    1px 1px 0 rgb(129, 29, 195);
}

.tray-div {
  position: relative;
  margin: 1rem 0;
}

.tray-images {
  position: relative;
}

.tray-images img {
  position: absolute;
}

.tray-images > .tray {
  position: relative;
}

.tray-div .coins-right,
.tray-div .coins-left {
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.coins-right {
  right: -12px;
}

.coins-left {
  left: -10px;
}

.tray {
  z-index: 2;
  display: block;
}

.tray-div .eggs-grid {
  width: 90%;
  position: absolute;
  top: 4.5rem;
  left: 3%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 16px;
  align-content: center;
  z-index: 3;
}

.tray-div .eggs-grid .egg-smash {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  bottom: 3rem;
}

.tray-div .egg-smash > div {
  position: absolute;
  bottom: 0;
  cursor: pointer;
  width: 70px;
}

.tray-div .egg-smash > img {
  display: none;
}

.tray-div .egg-smash > img.egg {
  display: block;
}

.t_c {
  background: rgb(112, 22, 171);
}

.t_c p {
  padding: 10px 16px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
}

.t_c p ul{
  padding: inherit;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
}

.modal-bg {
  max-width: 300px;
}

.modal-bg.visible {
  display: block;
}

.modal-content {
  max-width: 300px;
  position: relative;
  background: transparent;
  border: none;
  border-radius: 0;
}

.close-modal {
  font-size: 20px;
  color: pink;
  position: absolute;
  top: 0;
  right: 1px;
  cursor: pointer;
  height: 30px;
  width: 30px;
}

.modal-actions {
  position: absolute;
  bottom: 0;
  right: 15px;
  display: flex;
}

.modal-actions img {
  cursor: pointer;
  width: 50%;
  height: 35px;
}
@media(max-width: 480px) {
  .t_c p{
    font-size: 12px;
  }
}
</style>